import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-search\">\r\n  <path id=\"icon-search_搜索\" class=\"cls-1\" d=\"M122.632,116.892a6.078,6.078,0,1,1-2.375.479,6.078,6.078,0,0,1,2.375-.479m0-1.408a7.51,7.51,0,1,0,7.51,7.51A7.51,7.51,0,0,0,122.632,115.484Zm9.786,18a.7.7,0,0,1-.5-.207l-3.567-3.567a.7.7,0,0,1,1-1l3.567,3.567a.7.7,0,0,1-.5,1.2Zm0,0\" transform=\"translate(-115.122 -115.484)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol